import { useCallback, useMemo } from "react";
import ResultDialog from ".";
import { useVisible } from "../../../../../../../utils/hooks/useVisible";

export const useResultDialog = ({ onClose }: { onClose?: () => void } = {}) => {
    const { visible, selected, open, close } = useVisible();

    const handleClose = useCallback(() => {
        close();
        onClose?.();
    }, [close, onClose]);

    const modal = useMemo(() => {
        return (
            <ResultDialog
                isOpen={visible}
                close={handleClose}
                values={selected}
            />
        );
    }, [handleClose, selected, visible]);

    return { open, modal };
}
